import { render } from "./MobileLayout.vue?vue&type=template&id=058a4fca"
import script from "./MobileLayout.vue?vue&type=script&steup=true&lang=js"
export * from "./MobileLayout.vue?vue&type=script&steup=true&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=058a4fca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__